import { Component, OnInit, Input, OnChanges, SimpleChanges, IterableDiffers, DoCheck, KeyValueChangeRecord,
   Output, EventEmitter } from '@angular/core';
import { FileModel } from 'src/app/models/FileModel';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import { DokumentiDialogComponent } from './dokumenti-dialog/dokumenti-dialog.component';
import { HelpdeskService } from 'src/app/services/delavci/helpdesk.service';
import { LoginPartnerService } from 'src/app/services/partner/login-partner/login-partner.service';
import { MainService } from 'src/app/services/delavci/main.service';
import { DomSanitizer } from '@angular/platform-browser';
import * as FileSaver from 'file-saver';
import { Partner } from 'src/app/models/Partner';
import { User } from 'src/app/models/User';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
@Component({
  selector: 'app-dokumenti',
  templateUrl: './dokumenti.component.html',
  styleUrls: ['./dokumenti.component.css']
})
export class DokumentiComponent implements OnInit {

  @Input() public dataRow;
  @Input() public fileArray: Array<FileModel>;
  @Output() updateDocuments: EventEmitter<boolean> = new EventEmitter();
  public iterableDiffer;
  public spinner = false;

  public files: File[] = [];
  public filesCount: number;
  public addFileShow = false;
  name = 'Angular 5';
  fileUrl;
  public sessionUserPartner;
  public currentUserPartner: Partner;
  public currentUserWorker: User;
  public currentUserName;
  constructor(public dialog: MatDialog, private helpdeskService: HelpdeskService, private loginPartnerService: LoginPartnerService,
    private mainService: MainService, private iterableDiffers: IterableDiffers, private sanitizer: DomSanitizer,
    private _snackBar: MatSnackBar) {
      this.iterableDiffer = iterableDiffers.find([]).create(null);
     }

  openDialog(files: FileModel) {
    const dialogRef = this.dialog.open(DokumentiDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.helpdeskService.deleteFile(files.path).subscribe(data => {
          this.helpdeskService.setFileToTask(this.loginPartnerService.currentSessionValue, this.mainService.currentUserValue,
            this.dataRow.id, 'DELETE', 'CODE_PARTNER.CONTACTDIARY', files.id , files.filename, files.path, null, null).subscribe(data => {
            this.updateDocuments.emit(true);
          }, error => {
            console.log(error);

          });
        }, error => {
          console.log(error);
          this.openSnackBar('Napaka pri brisanju: ' + error.statusText);
        });
      }
    });
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, '', {
      duration: 2000,
    });
  }

  ngOnInit() {
    if (!this.loginPartnerService.currentSessionValue) {
      this.sessionUserPartner = null;
    } else {
      this.sessionUserPartner = this.loginPartnerService.currentSessionValue;
    }
    if (!this.loginPartnerService.currentPartnerValue) {
      this.currentUserPartner = null;
    } else {
      this.currentUserPartner = this.loginPartnerService.currentPartnerValue;
      this.currentUserName = this.loginPartnerService.currentPartnerValue.fullName;
    }
    if (!this.mainService.currentUserValue) {
      this.currentUserWorker = null;
    } else {
      this.currentUserWorker = this.mainService.currentUserValue;
      this.currentUserName = this.mainService.currentUserValue.workerNameSmall;
    }  }

  onDowload(path, filename) {
    this.helpdeskService.downloadFile(path).subscribe(data => {
      FileSaver.saveAs(data, filename);
    }, error => {
      console.log(error);
    });
  }

  onFileSubmitted() {
    this.spinner = true;
    for (let item of this.files) {
      this.helpdeskService.postFile(item).subscribe(data => {
        const file: FileModel = data;
        this.helpdeskService.setFileToTask(this.sessionUserPartner, this.mainService.currentUserValue,
          this.dataRow.id, 'INSERT', 'CODE_PARTNER.CONTACTDIARY', null, file.filename, file.path, null, null).subscribe(data => {
          this.webServiceCalls();
          this.files = [];
          this.filesCount = 0;
          this.spinner = false;
        }, error => {
          console.log(error);
        });
      }, error => {
        console.log(error);
      });
    }
  }

  /* drag and drop files */

  onFileDropped($event) {
    this.toFileList($event);

  }

  fileBrowseHandler(files) {
    this.toFileList(files);
  }

  toFileList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
      this.filesCount = this.files.length;
    }
  }

  uploadFile(index: number) {

  }

  deleteFile(index: number) {
    this.files.splice(index, 1);
    this.filesCount = this.files.length;
  }

  showAddFile() {
    this.addFileShow = true;
  }

  webServiceCalls() {

    this.helpdeskService.getHelpDeskFiles(this.loginPartnerService.currentSessionValue,
      this.mainService.currentUserValue, this.loginPartnerService.currentPartnerValue, this.dataRow.id).subscribe(data => {
        this.fileArray = [];
        for (let i = 0; i < data.data.files.length; i++) {
          let newFile: FileModel = new FileModel;
          newFile.filename = data.data.files[i].name;
          newFile.path = data.data.files[i].path;
          newFile.id = data.data.files[i].id;
          this.fileArray.push(newFile);
        }
      }, error => {
        console.log(error);
      });
  }

}
